import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const FavoritesContext = createContext(null);

export function FavoritesProvider({ children }) {
  const [favoriteTeams, setFavoriteTeams] = useState(() => {
    try { return JSON.parse(localStorage.getItem('favorite_teams') || '[]'); } catch { return []; }
  });

  const [notifications, setNotifications] = useState(() => {
    try { return JSON.parse(localStorage.getItem('notifications') || '[]'); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem('favorite_teams', JSON.stringify(favoriteTeams));
  }, [favoriteTeams]);

  useEffect(() => {
    localStorage.setItem('notifications', JSON.stringify(notifications));
  }, [notifications]);

  const toggleFavorite = useCallback((teamId, teamName) => {
    setFavoriteTeams(prev => {
      const exists = prev.find(t => t.id === teamId);
      if (exists) return prev.filter(t => t.id !== teamId);
      return [...prev, { id: teamId, name: teamName }];
    });
  }, []);

  const isFavorite = useCallback((teamId) => {
    return favoriteTeams.some(t => t.id === teamId);
  }, [favoriteTeams]);

  const addNotification = useCallback((notif) => {
    setNotifications(prev => [{ ...notif, id: Date.now(), read: false, time: new Date().toISOString() }, ...prev].slice(0, 50));
  }, []);

  const markAllRead = useCallback(() => {
    setNotifications(prev => prev.map(n => ({ ...n, read: true })));
  }, []);

  const clearNotifications = useCallback(() => {
    setNotifications([]);
  }, []);

  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <FavoritesContext.Provider value={{
      favoriteTeams, toggleFavorite, isFavorite,
      notifications, addNotification, markAllRead, clearNotifications, unreadCount,
    }}>
      {children}
    </FavoritesContext.Provider>
  );
}

export const useFavorites = () => useContext(FavoritesContext);
